import { call, put, takeEvery } from 'redux-saga/effects'
import { generalDoFailure } from '../../../util/fetchFailure'
import { privateFetch } from '../../../fetch'

import { API_URL_PATH_KEG_COLLECTIONS } from '../../../../../constants'

import {
  editKegCollectionRequest,
  editKegCollectionRequestSuccess,
  editKegCollectionRequestFailure,
  saveEditedKegCollection,
} from './utils'

import { UPDATE_KEG_COLLECTION } from '../../../../actions/actionTypes'

function* editKegCollectionRequestWorker(action) {
  if (!action) return
  const { kegCollectionId, updatedKegCollectionParams } = action.payload || {}

  yield put(editKegCollectionRequest())

  try {
    yield call(privateFetch, {
      path: `${API_URL_PATH_KEG_COLLECTIONS}/${kegCollectionId}`,
      method: 'PUT',
      data: updatedKegCollectionParams,
    })

    yield call(doSuccess)
  } catch (error) {
    yield call(doFailure, error)
  }
}

export default [[takeEvery, UPDATE_KEG_COLLECTION, editKegCollectionRequestWorker]]

function* doSuccess() {
  yield put(saveEditedKegCollection())
  yield put(editKegCollectionRequestSuccess())
}

function* doFailure(error) {
  yield call(generalDoFailure, {
    error,
    action: editKegCollectionRequestFailure(error),
  })
}
